import { AxiosConfig } from "./AxiosConfig";
import { UserHistoryResult } from "../models/UserHistoryResult";
import { UserHistoryFilter } from "../models/Master/UserHistoryFilter";
import saveAs from "file-saver";
import { AuthUtil } from "../utils/AuthUtil";
import axios from "axios";

const GetUserHistory = async (
  filterData: UserHistoryFilter,
  successCallback: (resposeObj: UserHistoryResult) => void,
  errorCallback: (error: Error) => void
) => {
  try {
    const resp = await AxiosConfig.post("/UserHistory/GetUserHistory", filterData);
    successCallback(resp.data);
  } catch (err: any) {
    // Handle Error Here
    console.error(err);
    errorCallback(err);
  }
};

const downlodReport = async (
  filterdata:UserHistoryFilter, 
  successCallback: (success: any) => void,
  errorCallback: (error: Error) => void
) => {
      let url = process.env.REACT_APP_BASE_URL + "UserHistory/GetExcelStream";
      axios({
        //  headers: {'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
        //      ,'authorization' : `Bearer ${AuthUtil.getAuthHeaderTocken()}`
       //   },
        headers: {'x-api-key' : process.env.REACT_APP_APIM_SUBSCRIPTION_KEY
              ,'authorization' : `Bearer ${AuthUtil.getAuthHeaderTocken()}`
          },
          
          method: 'post',
          responseType: 'arraybuffer', //Force to receive data in a Blob Format
          url: url,
          data: filterdata
      })
          .then(res => {
             
              let fileName = "report.xlsx";
             const blob = new Blob([res.data], {
                  type: 'application/octet-stream'
              });
  
              saveAs(blob, fileName);
              console.log(res);
              successCallback(true);
          })
          .catch(error => {
              console.log(error.message);
              errorCallback(error)
          });
};

export const UserHistoryService = {
  GetUserHistory,
  downlodReport
};
